'use client';

import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import produce from 'immer';
import { useRouter } from 'next/navigation';
import toast from 'react-hot-toast';
import { useAuth } from 'react-oidc-context';

import { getFeedbackThread } from '../../../apis/feedbacks';
import { findAndReshape } from '../../../helpers/feedbacks/reshapeFeedback';
import type { TopicInfoType } from '../../../types/feedbacks';

export const useFeedbackThread = (thread: string, topicInfo: TopicInfoType) => {
  const { isLoading, user: sessionData } = useAuth();
  const router = useRouter();

  return useQuery(
    ['feedbacks', thread],
    async () => {
      const result = await getFeedbackThread(thread, sessionData?.access_token as string);

      const reshaped = produce(result, (draft) => {
        const feedback = draft.data;
        if ((feedback.type === 'Comment' || feedback.type === 'Review') && 'commentChildren' in feedback) {
          feedback.commentChildren = findAndReshape(feedback.commentChildren);
        }
      });

      return reshaped.data;
    },
    {
      enabled: !!thread && !isLoading,
      onError: (err: AxiosError) => {
        if (err.response?.status === 404 && !!thread) {
          router?.push(`${window.origin}/${topicInfo.topicSlug}#comments`, {
            scroll: true,
          });
          toast.error('رشته دیدگاه مدنظر حذف شده است', { id: 'not found thread' });
        }
      },
    },
  );
};
